import { isEqual } from 'lodash';
import { FilterState, FilterType } from '../types/state';

export const createFilterAdapter = <SliceState, Filters extends FilterType>({
  selectState,
  emptyFilters,
  reset,
}: {
  selectState: (state: SliceState) => FilterState<Filters>;
  emptyFilters: Filters;
  reset?: (state: SliceState) => void;
}) => ({
  setFilter: (sliceState: SliceState, { payload: filterPatch }: { payload: Partial<Filters> }) => {
    const state = selectState(sliceState);
    state.filters = { ...state.filters, ...filterPatch };
  },
  clearAllFilters: (sliceState: SliceState) => {
    const state = selectState(sliceState);
    if (
      ('search' in emptyFilters && !isEqual({ ...state.appliedFilters, search: '' }, emptyFilters)) ||
      (!('search' in emptyFilters) && !isEqual(state.appliedFilters, emptyFilters))
    ) {
      reset?.(sliceState);
    }
    state.filters = 'search' in state.filters ? { ...emptyFilters, search: state.filters.search } : emptyFilters; // keep search
    state.appliedFilters =
      'search' in state.appliedFilters ? { ...emptyFilters, search: state.appliedFilters.search } : emptyFilters;
  },
  applyFilters: (sliceState: SliceState) => {
    const state = selectState(sliceState);
    if (!isEqual(state.appliedFilters, state.filters)) {
      reset?.(sliceState);
    }
    state.appliedFilters = state.filters;
  },
  clearFilter: <K extends keyof Filters>(sliceState: SliceState, { payload: key }: { payload: K }) => {
    const state = selectState(sliceState);
    state.filters = { ...state.filters, [key]: emptyFilters[key] };
  },
});
